






















































import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import { getLiveList } from '../api';
Vue.use(List);
@Component
export default class LiveList extends Vue {
  loading = false;
  finished = false;
  page = 1;
  liveList: any[] = [];

  created() {
    this.getLiveListAsync();
  }
  async getLiveListAsync() {
    if (this.finished) {
      return console.log('没有更多了');
    }
    this.loading = true;
    const ret = await getLiveList({
      page: this.page,
    });
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.page++;
      this.liveList = [...this.liveList, ...ret.data];
    } else {
      this.finished = true;
    }
  }
  onNavToDetail(data: any) {
    console.log(data);
    const { id, classId, dataType } = data;
    if (window.udid && data.dataType !== 7 && data.dataType !== 5) {
      const option = {
        dt: dataType,
        cid: classId,
        nid: id,
      };
      window.handleMessage(
        JSON.stringify({
          action: 'mJump',
          data: JSON.stringify(option),
        }),
      );
    } else {
      location.href = `https://wap.cqcb.com/shangyou_news/LiveDetail?classId=${classId}&newsId=${id}`;
    }
  }
}
